import home from "./home/index.js";
import recruit from "./recruit/index.js";
import column from "./column/index.js";
import searchArea from "./search/area.js";
import searchSchool from "./search/school.js";
import searchStation from "./search/station.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import shopDetail from "./shop/detail.js";
import SearchMap from "./search/map/index.js";
import assessment from "./assessment/index.js";

const pages = () => {
    home();
    recruit();
    column();
    searchArea();
    searchSchool();
    searchStation();
    estateIndex();
    estateDetail();
    shopDetail();
    SearchMap();
    assessment();
};

export default pages;
